"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDefaultEmptySectionToken = exports.QuoteSectionConfig = exports.tokenIsQuoteSectionToken = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var QuoteSection_1 = __importDefault(require("@CommonFrontend/Public/Widgets/QuoteSection"));
var Types_1 = require("@CommonFrontendBackend/Quote/Types");
var lodash_1 = require("lodash");
var Token_1 = require("@CommonFrontend/ContentTokens/Token");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var QuoteSectionBodyWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSection/QuoteSectionBodyWidget");
var QuoteLineItem_1 = require("./QuoteLineItem");
var pages_common_1 = require("@qwilr/pages-common");
var QuoteWidgetUtils_1 = require("./QuoteWidgetUtils");
var QuoteSectionWidget_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSection/QuoteSectionWidget.css");
var tokenIsQuoteSectionToken = function (token) {
    return token.type === "block" && token.subType === "quoteSection";
};
exports.tokenIsQuoteSectionToken = tokenIsQuoteSectionToken;
exports.QuoteSectionConfig = {
    type: "quoteSection",
    tokenType: {},
    publicRenderHtmlString: function (_a) {
        var attributes = _a.attributes, renderTokens = _a.renderTokens, token = _a.token, quoteContext = _a.quoteContext;
        var widgetId = (0, Token_1.tokenHasWidgetId)(token) ? token.widgetId : null;
        (0, tiny_invariant_1.default)(!!widgetId, "section doesn't have a widget ID");
        (0, tiny_invariant_1.default)(quoteContext, "no quote context was available when rendering section");
        var section = (0, lodash_1.omit)(token, ["type", "subType", "headingContent", "bodyContent"]);
        var price = (0, Helpers_1.getPriceSummaryTotalForItem)(quoteContext.priceSummary, widgetId);
        var body = renderWithColumnHeaders(token.bodyContent, renderTokens, section.currencyFormat);
        return server_1.default.renderToString(react_1.default.createElement(QuoteSection_1.default, {
            attributes: attributes,
            heading: renderTokens(token.headingContent, { computeForegroundColor: function (preferredForegroundColor) {
                    return (0, pages_common_1.goldilocks)(QuoteSectionWidget_css_1.quoteSectionBannerColor, { mode: "text", foregroundColor: preferredForegroundColor });
                },
            }),
            body: body,
            section: section,
            price: price,
            accountQuoteSettings: quoteContext.accountQuoteSettings,
            quoteLabelSetId: quoteContext.quoteLabelSetId,
            id: widgetId,
            projectCurrency: quoteContext.projectCurrency,
        }));
    },
    flattenForComments: function (currentToken, flattenedTokens) {
        (0, lodash_1.flattenDeep)([currentToken.headingContent, currentToken.bodyContent])
            .forEach(function (t) { return flattenedTokens.push(t); });
    },
    tokenTraversers: {
        getFlatFromListOfTokens: function (token, runFlat) {
            var _a, _b, item, e_1_1, _c, _d, item, e_2_1;
            var e_1, _e, e_2, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4, token];
                    case 1:
                        _g.sent();
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 7, 8, 9]);
                        _a = __values(runFlat(token.headingContent)), _b = _a.next();
                        _g.label = 3;
                    case 3:
                        if (!!_b.done) return [3, 6];
                        item = _b.value;
                        return [4, item];
                    case 4:
                        _g.sent();
                        _g.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 9:
                        _g.trys.push([9, 14, 15, 16]);
                        _c = __values(runFlat(token.bodyContent)), _d = _c.next();
                        _g.label = 10;
                    case 10:
                        if (!!_d.done) return [3, 13];
                        item = _d.value;
                        return [4, item];
                    case 11:
                        _g.sent();
                        _g.label = 12;
                    case 12:
                        _d = _c.next();
                        return [3, 10];
                    case 13: return [3, 16];
                    case 14:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 16];
                    case 15:
                        try {
                            if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7];
                    case 16: return [2];
                }
            });
        },
        getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
            token.headingContent = unpackAndTransformFn(token.headingContent);
            token.bodyContent = unpackAndTransformFn(token.bodyContent);
            return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
        },
    },
    traits: {
        widgetId: {},
        spacingShim: {
            className: QuoteSectionWidget_css_1.spacingShim,
        },
    },
};
function renderWithColumnHeaders(bodyContent, renderTokens, currencyFormat) {
    var e_3, _a;
    var columnHeaders = (0, QuoteSectionBodyWidget_1.deriveColumnHeaders)(bodyContent, function (t) { return (0, QuoteLineItem_1.tokenIsQuoteLineItemToken)(t) ? t : null; });
    var bodyContentWithHeaders = [];
    try {
        for (var _b = __values(bodyContent.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), index = _d[0], t = _d[1];
            var columnHeader = columnHeaders.get(index);
            if (columnHeader) {
                bodyContentWithHeaders.push({
                    type: "block",
                    subType: "quoteColumnHeader",
                    data: columnHeader,
                });
            }
            bodyContentWithHeaders.push(t);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return renderTokens(bodyContentWithHeaders, { quoteSectionContext: { currencyFormat: currencyFormat }, computeForegroundColor: function (preferredForegroundColor) {
            return (0, pages_common_1.goldilocks)(QuoteSectionWidget_css_1.quoteSectionBodyColor, { mode: "text", foregroundColor: preferredForegroundColor });
        }, });
}
var buildDefaultEmptySectionToken = function () { return ({
    type: "block",
    display: (0, Types_1.createDefaultQuoteSectionDisplayData)(),
    subType: "quoteSection",
    headingContent: [(0, QuoteWidgetUtils_1.createEmptyToken)("heading2"), (0, QuoteWidgetUtils_1.createTextToken)("")],
    bodyContent: [(0, QuoteWidgetUtils_1.createEmptyToken)("paragraph"), (0, QuoteWidgetUtils_1.createTextToken)("")],
    hiddenLabels: [],
    selection: { mode: "required" },
    priceContext: (0, QuoteWidgetUtils_1.createPriceContext)(),
    currencyFormat: { type: "inherit" },
}); };
exports.buildDefaultEmptySectionToken = buildDefaultEmptySectionToken;
